<template>
  <div class="info-wrapper">
    <div class="top">
      <div class="address">
        <svg class="business-icon">
          <use xlink:href="#icon-center"></use>
        </svg>
        {{ business.address }}
        {{ business.city.postal_code }}
        {{ business.city.label }}
      </div>
      <p class="sub-title">
        {{ $t('commons.hours') }}
      </p>
      <div class="hours">
        {{ weekdaysTxt }}
        <br>
        {{ weekendsTxt }}
      </div>
      <p class="sub-title">
        {{ $t('commons.contact') }}
      </p>
      <div class="clickable">
        <svg class="icon-phone">
          <use xlink:href="#icon-phone"></use>
        </svg>
        <div
          class="clickable-txt"
          @click="phoneVisible = true"
          v-if="!phoneVisible"
        >
          {{ $t('commons.show_phone') }}
        </div>
        <div
          v-else
          class="numbers"
        >
          Tél&nbsp;:{{ business.phone }}
          <!--
          <template v-if="business.fax">
            Fax&nbsp;:{{ business.fax }}<br>
          </template>
          -->
        </div>
      </div>
      <a :href="`/contact/particulier?business_id=${business.id}`">
        <svg class="icon-email">
          <use xlink:href="#icon-email"></use>
        </svg>
        Contacter par email
      </a>
    </div>

    <div class="bottom">
      <rent-button
        :loading="loading"
        @buttonclicked="onSelect"
      >
        {{ actionButtonTxt }}
      </rent-button>
    </div>
  </div>
</template>
<script>
import businessHours from '../../shared/mixins/businessHours';
import onSelectBusiness from '../../shared/mixins/onSelectBusiness'
import RentButton from '../../shared/RentButton'

export default {
  name: 'BusinessBasicInfo',
  mixins: [businessHours, onSelectBusiness],
  components: {
    RentButton,
  },
  props: {
    business: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      phoneVisible: false,
    }
  },
  computed: {
    isSelectedBusiness() {
      const storeBusiness = this.$store.state.booking.pickUp.business;

      if (storeBusiness && storeBusiness.id === this.business.id) {
        return true
      }
      return false
    },
    actionButtonTxt() {
      return this.isSelectedBusiness ? this.$t('commons.continue') : this.$t('commons.select')
    },
  },
};
</script>
<style lang="scss" scoped>

.info-wrapper {
  background: $c-alabaster;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 35px;
  width: 100%;
}

.address {
  align-items: flex-end;
  color: $c-tundora;
  display: flex;
  font-family: $f-graphie-bold;
  margin: 0 0 20px;
  text-transform: uppercase;

  @include font-size(13px);
}

.business-icon {
  height: 28px;
  width: 28px;
}

h2 {
  color: $c-tundora;

  @include font-size(11px);
}

.hours {
  @include font-size(11px);

  margin: 0 0 20px;
}

.icon-phone,
.icon-email {
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.icon-phone {
  height: 18px;
  transform: translate(2px, -50%);
  width: 15px;
}

.icon-email {
  height: 18px;
  width: 20px;
}

a,
.clickable {
  align-items: center;
  color: black;
  cursor: pointer;
  display: flex;
  margin: 10px 0;
  padding: 0 0 0 30px;
  position: relative;

  @include font-size(11px);
}

a,
.clickable-txt {
  text-decoration: underline;
}

a {
  margin: 10px 0 30px;
}

.numbers {
  text-decoration: none;
}

.sub-title {
  font-size: 1.4rem;
}
</style>
